import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import Form, { Actions, AllowedTimes, Switch } from '../../Components/Form';
import { useJournal } from '../../Data/Journal';

const Notifications = () => {
    const {journal, updateNotificationPreferences} = useJournal();

    return <>
        <TopBar left="BackBtn" title="Notifications" />

        <Page>
            <div className="prose my-4 text-muted text-balance">
                <p>
                    Choose how you would like to receive notifications from getSoapy.<br />
                    These include notifications for new messages, quotes, payments, and other important updates.
                </p>
            </div>

            <Form data={journal?.notificationPreferences} waitForData onSubmit={updateNotificationPreferences} goBackOnSubmit>
                <Switch name="sendSMS" label="Send SMS" />
                <Switch name="sendPush" label="Send App Notifications" />
                <Switch name="sendEmail" label="Send Emails" />
                <AllowedTimes name="allowedTimes"
                    label="Allowed times"
                    help={val => val === null ?
                        'You will receive notifications as they arrive' :
                        `Notifications sent after ${val.latest} will be delayed until ${val.earliest} the next day`
                    }
                />
                <Actions submit={{label: 'Save'}} />
            </Form>

        </Page>
    </>
}

export default Notifications;
